import { Reveal, MaskText, Stagger, StaggerItem } from "./Reveal";

const MOVES = [
  ["Keep", "What still belongs in the plan?"],
  ["Change", "What has reality taught you?"],
  ["Stop", "What no longer deserves your time?"],
  ["Start", "What matters now that didn't matter before?"],
  ["Return to Basics", "What foundation needs attention before you make the next leap?"],
];

export const Reset = () => (
  <section id="reset" className="relative bg-cream py-24 sm:py-32">
    <div className="mx-auto max-w-[1300px] px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-y-10 gap-x-12 items-end">
        <div className="lg:col-span-6">
          <span className="font-sans text-xs uppercase tracking-[0.28em] text-cognac">Evergreen · The Roadmap Reset</span>
          <h2 className="mt-6 font-serif text-ocean tracking-[-0.02em] leading-[0.96] text-4xl sm:text-6xl lg:text-[4.6rem]">
            <MaskText lines={["Build it once.", <span key="y" className="italic text-cognac">Use it for years.</span>]} />
          </h2>
        </div>
        <div className="lg:col-span-6 lg:pl-8 lg:border-l border-[var(--line)] font-sans text-base sm:text-lg text-ink/75 leading-relaxed space-y-4">
          <Reveal>
            <p>
              Six months from now, your business may look completely different.{" "}
              <span className="font-serif italic text-2xl text-ocean">Good.</span>
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p>Come back. Run a Roadmap Reset. Tell the system what changed. Then reassess:</p>
          </Reveal>
        </div>
      </div>

      <Stagger className="mt-16 grid md:grid-cols-5 gap-px bg-[var(--line)] border border-[var(--line)]" amount={0.08}>
        {MOVES.map(([t, q], i) => (
          <StaggerItem key={t} className="bg-cream p-7 sm:p-8 group hover:bg-ocean transition-colors duration-500 min-h-[220px] flex flex-col justify-between">
            <span className="font-sans text-[10px] tracking-[0.2em] text-cognac">{String(i + 1).padStart(2, "0")}</span>
            <div>
              <h3 className="font-serif text-3xl sm:text-[2rem] text-ocean group-hover:text-cream tracking-tight leading-none transition-colors duration-500">{t}</h3>
              <p className="mt-4 font-sans text-sm text-ink/65 group-hover:text-cream/70 leading-relaxed transition-colors duration-500">{q}</p>
            </div>
          </StaggerItem>
        ))}
      </Stagger>

      <Reveal delay={0.1}>
        <p className="mt-16 font-serif text-2xl sm:text-4xl text-ocean tracking-tight leading-snug max-w-3xl">
          Your roadmap isn't supposed to stay the same.
          <span className="block italic text-cognac">It's supposed to grow with you.</span>
        </p>
      </Reveal>
    </div>
  </section>
);
